import { Component, OnInit } from '@angular/core';
import { BBWTMessageService, SettingsService } from '../../services';
import Quill from 'quill';

@Component({
  templateUrl: './order-creation-notification-admin.component.html',
  styleUrls: ['./order-creation-notification-admin.component.scss'],
})
export class OrderCreationNotificationAdminComponent implements OnInit {
  constructor(
    private settingsService: SettingsService,
    private messageService: BBWTMessageService,
  ) {}

  editorToolbarOptions = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // etc.

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ align: [] }],

      ['clean'], // remove formatting button
    ],
  };

  private readonly SettingName = 'OrderCreationNotificationMessage';
  public setting: any = {};
  notificationQuillEditor: Quill;

  ngOnInit() {
    // load current system setting for order creation notification
    this.settingsService.GetSettingsList().then((settings) => {
      this.setting = settings.find((x) => x.name == this.SettingName);
    });
  }

  save() {
    // quill returns text with html tags included, so when the editor is not cleared using the button and is backspaced instead,
    // the text in the editor appears blank/whitespace, but quill returns format tags, e.g. <p>...</p>, which is saved as the system setting value
    // this causes the notification message to appear whilst creating a job as the setting.length > 0 even though it's all just whitespace.
    // the clear button should prevent this, but this is an extra catch.
    const plainText = this.notificationQuillEditor.getText().trim();

    if (plainText.length === 0) {
      this.setting.value = '';
    }

    // update the relevant system setting
    this.settingsService
      .save({ id: this.setting.id, name: this.SettingName, value: this.setting.value })
      .then((result) => {
        if (result) {
          this.messageService.ShowSuccess(
            'Notification Saved',
            'Order notification text was saved',
          );
        } else {
          this.messageService.ShowError('Error', 'Failed to save order notification text');
        }
      });
  }

  clearText() {
    this.setting.value = '';
  }

  getEditorInstance(quillInstance: Quill) {
    this.notificationQuillEditor = quillInstance;
  }
}
